var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "maskMember", staticClass: "maskMember" }, [
    _c("div", { staticClass: "member" }, [
      _c("div", { staticClass: "box login active" }, [
        _c("h1", { staticClass: "title", attrs: { i18n: "login_title" } }, [
          _vm._v("Log in to Aiseesoft"),
        ]),
        _vm._m(0),
        _vm._m(1),
        _vm._m(2),
        _c("span", { staticClass: "btn login_btn", on: { click: _vm.log } }, [
          _c("span", { attrs: { i18n: "log_in" } }, [_vm._v("Log In")]),
          _c("img", {
            attrs: {
              src: "https://account.aiseesoft.com/images/loading.svg",
              alt: "Loading",
            },
          }),
          _c("p"),
        ]),
        _vm._m(3),
        _vm._m(4),
      ]),
      _vm._m(5),
      _c("div", { staticClass: "box register" }, [
        _c("h1", { staticClass: "title", attrs: { i18n: "sign_up" } }, [
          _vm._v("Sign Up"),
        ]),
        _c("p", { staticClass: "subtitle", attrs: { i18n: "register_info" } }, [
          _vm._v("Create your account"),
        ]),
        _vm._m(6),
        _vm._m(7),
        _c(
          "span",
          { staticClass: "btn register_btn", on: { click: _vm.log } },
          [
            _c("span", { attrs: { i18n: "sign_up" } }, [_vm._v("Sign Up")]),
            _c("img", {
              attrs: {
                src: "https://account.aiseesoft.com/images/loading.svg",
                alt: "Loading",
              },
            }),
            _c("p"),
          ]
        ),
        _vm._m(8),
        _vm._m(9),
        _vm._m(10),
      ]),
      _vm._m(11),
      _vm._m(12),
      _c("div", { staticClass: "box reset" }, [
        _c("h1", { staticClass: "title", attrs: { i18n: "forgot_password" } }, [
          _vm._v("Forgot Password"),
        ]),
        _c(
          "p",
          {
            staticClass: "subtitle",
            attrs: { i18n: "reset_password_subtitle" },
          },
          [_vm._v("Use your account email to reset password")]
        ),
        _vm._m(13),
        _vm._m(14),
        _vm._m(15),
        _vm._m(16),
        _c("span", { staticClass: "btn reset_btn", on: { click: _vm.log } }, [
          _c("span", { attrs: { i18n: "reset_now" } }, [_vm._v("Reset Now")]),
          _c("p"),
        ]),
        _vm._m(17),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input_box" }, [
      _c("input", {
        staticClass: "email",
        attrs: {
          type: "text",
          i18n_input: "email_placeholder",
          placeholder: "Email",
        },
      }),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "password_box input_box" }, [
      _c("input", {
        staticClass: "password",
        attrs: {
          type: "password",
          i18n_input: "password_placeholder",
          placeholder: "Password",
          autocomplete: "off",
        },
      }),
      _c("p"),
      _c("div", [
        _c("img", {
          attrs: {
            src: "https://account.aiseesoft.com/images/hide.svg",
            i18n_title: "hide_password",
            title: "Hide password",
            loading: "lazy",
            alt: "Hide",
          },
        }),
        _c("img", {
          attrs: {
            src: "https://account.aiseesoft.com/images/show.svg",
            i18n_title: "show_password",
            title: "Show password",
            loading: "lazy",
            alt: "Show",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "forgot_password" }, [
      _c(
        "a",
        {
          staticClass: "forgot_password_a",
          attrs: { i18n: "forgot_password" },
        },
        [_vm._v("Forgot password?")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "create_account" }, [
      _c("span", { attrs: { i18n: "no_account" } }, [_vm._v("No account?")]),
      _vm._v(" "),
      _c("a", { staticClass: "create_it", attrs: { i18n: "create_it" } }, [
        _vm._v("Create it"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "third_party" }, [
      _c("p", { staticClass: "flex_box" }, [
        _c("span", { attrs: { i18n: "or_log_in_with" } }, [
          _vm._v("Or log in with"),
        ]),
      ]),
      _c("div", { staticClass: "flex_box" }, [
        _c("div", { staticClass: "google_a" }, [
          _c("img", {
            attrs: {
              src: "https://account.aiseesoft.com/images/google-btn.svg",
              alt: "Google",
            },
          }),
          _c("span", { attrs: { i18n: "google_login" } }, [
            _vm._v("Sign in with Google"),
          ]),
        ]),
        _c("a", { staticClass: "passwordless_login" }, [
          _c("img", {
            attrs: {
              src: "https://account.aiseesoft.com/images/passwordless.svg",
              alt: "Passwordless",
            },
          }),
          _c("span", { attrs: { i18n: "passwordless_login" } }, [
            _vm._v("Passwordless login"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box passless_login" }, [
      _c(
        "h1",
        { staticClass: "title", attrs: { i18n: "passwordless_login" } },
        [_vm._v("Passwordless Login")]
      ),
      _c(
        "p",
        { staticClass: "subtitle", attrs: { i18n: "password_login_subtitle" } },
        [_vm._v("Passwordless login with email")]
      ),
      _c("div", { staticClass: "input_box" }, [
        _c("input", {
          staticClass: "email",
          attrs: {
            value: "",
            type: "text",
            i18n_input: "email_placeholder",
            placeholder: "Email",
          },
        }),
        _c("p"),
      ]),
      _c("div", { staticClass: "code_box flex_box input_box" }, [
        _c("input", {
          staticClass: "code",
          attrs: {
            type: "text",
            i18n_input: "code_placeholder",
            placeholder: "Verification Code",
            readonly: "true",
          },
        }),
        _c("span", { staticClass: "getcode", attrs: { i18n: "Get" } }, [
          _vm._v("Get"),
        ]),
        _c("p"),
      ]),
      _c("span", { staticClass: "btn passless_login_btn" }, [
        _c("span", { attrs: { i18n: "log_in" } }, [_vm._v("Log In")]),
        _c("img", {
          attrs: {
            src: "https://account.aiseesoft.com/images/loading.svg",
            alt: "Loading",
          },
        }),
        _c("p"),
      ]),
      _c("div", { staticClass: "third_party" }, [
        _c("p", { staticClass: "flex_box" }, [
          _c("span", { attrs: { i18n: "or_log_in_with" } }, [
            _vm._v("Or log in with"),
          ]),
        ]),
        _c("div", { staticClass: "flex_box" }, [
          _c("div", { staticClass: "google_a" }, [
            _c("img", {
              attrs: {
                src: "https://account.aiseesoft.com/images/google-btn.svg",
                alt: "Google",
              },
            }),
            _c("span", { attrs: { i18n: "google_login" } }, [
              _vm._v("Sign in with Google"),
            ]),
          ]),
          _c("a", { staticClass: "passwordless_login back_to_log_in" }, [
            _c("img", {
              attrs: {
                src: "https://account.aiseesoft.com/images/my.svg",
                alt: "My",
              },
            }),
            _c("span", { attrs: { i18n: "account_login" } }, [
              _vm._v("Account Login"),
            ]),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "create_account" }, [
        _c("span", { attrs: { i18n: "no_account" } }, [_vm._v("No account?")]),
        _vm._v(" "),
        _c("a", { staticClass: "create_it", attrs: { i18n: "create_it" } }, [
          _vm._v("Create it"),
        ]),
      ]),
      _c("p", { staticClass: "rights", attrs: { i18n: "rights" } }, [
        _vm._v("By creating this account, you agree with to "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.aiseesoft.com/company/terms-and-conditions.html",
            },
          },
          [_vm._v("Terms of Service")]
        ),
        _vm._v(" and "),
        _c(
          "a",
          { attrs: { href: "https://www.aiseesoft.com/privacy-policy.html" } },
          [_vm._v("Privacy Policy")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input_box" }, [
      _c("input", {
        staticClass: "email",
        attrs: {
          value: "",
          type: "text",
          i18n_input: "email_placeholder",
          placeholder: "Email",
        },
      }),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "password_box input_box" }, [
      _c("input", {
        staticClass: "password",
        attrs: {
          type: "password",
          i18n_input: "password_placeholder_1",
          placeholder: "Create your password",
          autocomplete: "off",
        },
      }),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "third_party" }, [
      _c("p", { staticClass: "flex_box" }, [
        _c("span", { attrs: { i18n: "or_log_in_with" } }, [
          _vm._v("Or log in with"),
        ]),
      ]),
      _c("div", { staticClass: "flex_box" }, [
        _c("div", { staticClass: "google_a" }, [
          _c("img", {
            attrs: {
              src: "https://account.aiseesoft.com/images/google-btn.svg",
              alt: "Google",
            },
          }),
          _c("span", { attrs: { i18n: "google_login" } }, [
            _vm._v("Sign in with Google"),
          ]),
        ]),
        _c("a", { staticClass: "passwordless_login" }, [
          _c("img", {
            attrs: {
              src: "https://account.aiseesoft.com/images/passwordless.svg",
              alt: "Passwordless",
            },
          }),
          _c("span", { attrs: { i18n: "passwordless_login" } }, [
            _vm._v("Passwordless login"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "back" }, [
      _c(
        "a",
        { staticClass: "back_to_log_in", attrs: { i18n: "back_to_log_in" } },
        [_vm._v("Back to log in")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "rights", attrs: { i18n: "rights" } }, [
      _vm._v("By creating this account, you agree with to "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.aiseesoft.com/company/terms-and-conditions.html",
          },
        },
        [_vm._v("Terms of Service")]
      ),
      _vm._v(" and "),
      _c(
        "a",
        { attrs: { href: "https://www.aiseesoft.com/privacy-policy.html" } },
        [_vm._v("Privacy Policy")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "box third_party_success success registration_succeeded" },
      [
        _c(
          "h1",
          { staticClass: "title", attrs: { i18n: "registration_succeeded" } },
          [_vm._v("Registration Succeeded")]
        ),
        _c("img", {
          attrs: {
            src: "https://account.aiseesoft.com/images/succes.svg",
            loading: "lazy",
            alt: "Succes",
          },
        }),
        _c(
          "p",
          {
            staticClass: "info",
            attrs: { i18n: "registration_succeeded_info_1" },
          },
          [
            _vm._v(
              "Congratulations! You have registered successfully. We have sent the verification message to your email "
            ),
            _c("span", { staticClass: "email" }),
            _vm._v(
              ", and please finish verifying to use the benefits of this email."
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "info",
            staticStyle: { display: "none" },
            attrs: { i18n: "registration_succeeded_info_2" },
          },
          [
            _vm._v(
              'Click "Finish" to return to the Home page and use this product.'
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "info operation",
            staticStyle: { display: "none" },
            attrs: { i18n: "registration_succeeded_info_3" },
          },
          [
            _vm._v(
              'Click "Finish" to close the current page and return to the Home page for the following operations. If closing fails, please manually close the tab.'
            ),
          ]
        ),
        _c("span", { staticClass: "btn done" }, [
          _c("span", { attrs: { i18n: "Done" } }, [_vm._v("Done")]),
          _c("p"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box third_party_registered success" }, [
      _c("h1", { staticClass: "title", attrs: { i18n: "login_title" } }, [
        _vm._v("Log in to AnyMP4"),
      ]),
      _c("img", {
        attrs: {
          src: "https://account.aiseesoft.com/images/doubt.svg",
          loading: "lazy",
          alt: "DDoubt",
        },
      }),
      _c(
        "p",
        {
          staticClass: "info",
          staticStyle: { "max-width": "320px" },
          attrs: { i18n: "three_rd_login_merge_account" },
        },
        [
          _vm._v(
            "The third-party account email address has been signed up, do you want to connect and log in with this email address directly?"
          ),
        ]
      ),
      _c("div", { staticClass: "input_box" }, [
        _c(
          "span",
          {
            staticClass: "third_party_registered_btn btn",
            attrs: { i18n: "connect_log_in" },
          },
          [_vm._v("Connect & Log In")]
        ),
        _c("p", { staticStyle: { "text-align": "center", width: "100%" } }),
      ]),
      _c("div", { staticClass: "third_party_registered_register" }, [
        _c("span", { attrs: { i18n: "create_an_account" } }, [
          _vm._v("Create an account"),
        ]),
        _c("p"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input_box" }, [
      _c("input", {
        staticClass: "email",
        attrs: {
          value: "",
          type: "text",
          i18n_input: "email_placeholder",
          placeholder: "Email",
        },
      }),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "code_box flex_box input_box" }, [
      _c("input", {
        staticClass: "code",
        attrs: {
          type: "text",
          i18n_input: "code_placeholder",
          placeholder: "Verification Code",
          readonly: "true",
        },
      }),
      _c("span", { staticClass: "getcode", attrs: { i18n: "Get" } }, [
        _vm._v("Get"),
      ]),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "password_box input_box" }, [
      _c("input", {
        staticClass: "password",
        attrs: {
          type: "password",
          i18n_input: "password_placeholder_3",
          placeholder: "Create new password",
          autocomplete: "off",
        },
      }),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "password_box input_box" }, [
      _c("input", {
        staticClass: "password copy_password",
        attrs: {
          type: "password",
          i18n_input: "password_placeholder_4",
          placeholder: "Confirm new password",
          autocomplete: "off",
          onpaste: "return false",
        },
      }),
      _c("p"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticStyle: { "margin-top": "20px", "text-align": "center" } },
      [
        _c(
          "a",
          { staticClass: "back_to_log_in", attrs: { i18n: "back_to_log_in" } },
          [_vm._v("Back to log in")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }